import { render, staticRenderFns } from "./BaseTLFileInput.vue?vue&type=template&id=6c70cabf&"
import script from "./BaseTLFileInput.vue?vue&type=script&lang=ts&"
export * from "./BaseTLFileInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports